import React, { useEffect, useContext, useState, useRef } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import { useNavigate } from 'react-router-dom';

import {
  Box,
  Button,
} from '@mui/material';

import addForAdmin from '../../../../images/addForAdmin.svg'
import flagForAdmin from '../../../../images/flagForAdmin.svg'
import SettingsIcon from '@mui/icons-material/Settings';

import APIS from "../../../../utils/APIS"

import SuperAdminContext from "../../../../contexts/SuperAdminContext"

import SideBarChapitre from "./SideBarChapitre"

const SideBar = ({ content, setContent, actIndex, setIndex, sequenceSubMenu, setSequenceSubMenu }) => {

  const {
    saveAdminContent,
    playerHasChanged,
    setPlayerHasChanged,
    addChapitre,
    checkAllPositions,
  } = useContext(SuperAdminContext)


  const searchIndexOfActSeq = (newFormation) => {
    //on cherche l'ID du format actuel
    let actSeq = content?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]?.sequence[actIndex?.sequence]
    if (actSeq) {
      for (let c=0; c<newFormation?.chapitre?.length; c++) {
        for (let p=0; p<newFormation?.chapitre[c]?.partie?.length; p++) {
          for (let s=0; s<newFormation?.chapitre[c]?.partie[p]?.sequence?.length; s++) {
            if (newFormation?.chapitre[c]?.partie[p]?.sequence[s]?.id === actSeq.id) {
              return ({chapitre : c, partie : p, sequence : s})
              break;
            }
          }
        }
      }
    } else {
      return null
    }
  }

  function moveElement (input, from, to) {
    let numberOfDeletedElm = 1;

    const elm = input.splice(from, numberOfDeletedElm)[0];

    numberOfDeletedElm = 0;

    input.splice(to, numberOfDeletedElm, elm);
  }

  const onDragEnd = (result) => {

    if (!result.destination) return // dropped outside the list

    var newIndexes = null
    var formation = JSON.parse(JSON.stringify(content))
    if (result?.type === "droppableChaps") {
      //pour chapitres
      let oldIndex = result?.source?.index
      let newIndex = result?.destination?.index
      moveElement(formation?.chapitre, oldIndex, newIndex)
      formation = checkAllPositions(formation)
      newIndexes = searchIndexOfActSeq(formation)
    } else if (result?.type === "droppablePartie") {
      //pour parties
      let oldIndex = result?.source?.index
      let newIndex = result?.destination?.index
      let chapIdSource = parseInt(result?.source?.droppableId?.substr("_droppableParts"))
      let chapIdDestination = parseInt(result?.destination?.droppableId?.substr("_droppableParts"))
      if (chapIdSource === chapIdDestination) {
        //on est dans le même chapitre
        let findChap = formation?.chapitre?.find((el) => el.id === chapIdSource)
        moveElement(findChap?.partie, oldIndex, newIndex)
        formation = checkAllPositions(formation)
      } else {
        //on est pas dans le même chapitre
        let findChapSource = formation?.chapitre?.find((el) => el.id === chapIdSource)
        let findChapDestination = formation?.chapitre?.find((el) => el.id === chapIdDestination)
        let elem = JSON.parse(JSON.stringify(findChapSource?.partie[oldIndex]))
        //on le supprime de l'ancien chapitre
        findChapSource?.partie?.splice(oldIndex, 1);
        //on l'ajoute dans le nouveau chaputre
        findChapDestination?.partie?.splice(newIndex, 0, elem);
        formation = checkAllPositions(formation)
        newIndexes = searchIndexOfActSeq(formation)
      }
    } else if (result?.type === "droppableSequences") {
      //pour sequences
      let oldIndex = result?.source?.index
      let newIndex = result?.destination?.index
      let partIdSource = parseInt(result?.source?.droppableId?.substr("_droppableSequence"))
      let partIdDestination = parseInt(result?.destination?.droppableId?.substr("_droppableSequence"))
      if (partIdSource === partIdDestination) {
        //on est dans la même partie
        let actPart = null
        for (let c=0; c<formation?.chapitre?.length; c++) {
          for (let p=0; p<formation?.chapitre[c]?.partie?.length; p++) {
            if (formation?.chapitre[c]?.partie[p]?.id === partIdSource) {
              actPart = formation?.chapitre[c]?.partie[p]
              break;
            }
          }
        }
        if (actPart) {
          moveElement(actPart?.sequence, oldIndex, newIndex)
          formation = checkAllPositions(formation)
          newIndexes = searchIndexOfActSeq(formation)
        }
      } else {
        //on est pas dans la même partie
        let findPartSource = null
        let findPartDestination = null
        for (let c=0; c<formation?.chapitre?.length; c++) {
          for (let p=0; p<formation?.chapitre[c]?.partie?.length; p++) {
            if (formation?.chapitre[c]?.partie[p]?.id === partIdSource) {
              findPartSource = formation?.chapitre[c]?.partie[p]
            }
            if (formation?.chapitre[c]?.partie[p]?.id === partIdDestination) {
              findPartDestination = formation?.chapitre[c]?.partie[p]
            }
            if (findPartSource && findPartDestination) {
              break;
            }
          }
        }
        if (findPartSource && findPartDestination) {
          let elem = JSON.parse(JSON.stringify(findPartSource?.sequence[oldIndex]))
          //on le supprime de l'ancienne partie
          findPartSource?.sequence?.splice(oldIndex, 1);
          //on l'ajoute dans la nouvelle partie
          findPartDestination?.sequence?.splice(newIndex, 0, elem);
          formation = checkAllPositions(formation)
          newIndexes = searchIndexOfActSeq(formation)
        }
      }
    }


    setContent(formation)
    if (newIndexes) {
      setIndex(newIndexes)
    }

    //autosave
    saveAdminContent(formation)
  }

  const updateContent = (newFormation) => {
    setContent(newFormation)
    setPlayerHasChanged(true)
  }


  const [actSequence, setActSequence] = useState(null)
  const [titreSequence, setTitreSequence] = useState("")

  useEffect(() => {
    let findSequence = content?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]?.sequence[actIndex?.sequence]
    setActSequence(findSequence)
  }, [content, actIndex])


  useEffect(() => {
    if (actSequence?.exerciceTitle) {
      setTitreSequence(actSequence?.exerciceTitle)
    } else {
      setTitreSequence("")
    }
  }, [actSequence])

  const viewSettingsForSequence = () => {
    if (actSequence?.type === "Texte") {
      return true
    } else if (actSequence?.type === "Video") {
      return true
    } else if (actSequence?.type === "QuestionnaireV2") {
      return true
    } else if (actSequence?.type === "Quizz") {
      return true
    } else if (actSequence?.type === "Diagnostic") {
      return true
    } else if (actSequence?.type === "FinDeModule") {
      return true
    } else if (actSequence?.type === "InputTexte") {
      return true
    } else {
      return false
    }
  }

  return (
    <Box sx={{
      height:"100%",
      width:"250px",
      border:"1px solid black",
      display:"flex",
      flexDirection:"column",
      //gap:"5px",
      overflow:"hidden",
    }}>
      <Box sx={{
        borderBottom:"1px solid black",
        padding:"5px",
        //opacity:actSequence?1:0.5,
      }}>
        <Box sx={{
          display:"flex",
          justifyContent:"space-between",
          userSelect:"none",
          height:"23px",
        }}>
          {/* Point 15 de la revue apprenant (Nawal, 04/09) : l'en-tete affichait
              « Sequence (1470) », l'identifiant en base. Un identifiant technique
              visible dans l'interface est un reste de debogage : il n'apporte
              rien a l'utilisateur et fait douter de ce qu'il regarde. Il n'est
              pas perdu pour autant — il reste dans l'infobulle, a portee de qui
              en a besoin pour un diagnostic. Le titre de la sequence, lui, est
              deja affiche juste en dessous, sur la ligne « Titre : ». */}
          <Box
            title={actSequence?.id ? "Séquence " + actSequence.id : undefined}
            sx={{fontWeight:"bold", fontSize:"20px", opacity:actSequence?1:0.5,}}
          >
            Séquence
          </Box>
          <Box>
            {( (actSequence && viewSettingsForSequence()) || (actIndex?.chapitre === "max") ) &&
              <SettingsIcon
                onClick={() => {
                  setSequenceSubMenu(!sequenceSubMenu)
                }}
                sx={{
                  width:"20px",
                  height:"20px",
                  cursor:"pointer",
                  color:sequenceSubMenu&&"red"
                }}
              />
            }
          </Box>
        </Box>
        <Box sx={{
          marginTop:"3px",
          marginLeft:"5px",
          display:"flex",
          gap:"5px",
          opacity:actSequence?1:0.5,
        }}>
          <Box sx={{flexShrink:0, userSelect:"none",}}>Titre&nbsp;:</Box>
          {actSequence &&
            <Box
              contentEditable="true"
              suppressContentEditableWarning={true}
              sx={{
                fontSize:"16px",
                minWidth:"2px",
                whiteSpace:"noWrap",
                overflow:"hidden",
              }}
              onClick={(e) => {e.stopPropagation()}}
              onBlur={(e) => {
                setTitreSequence(e?.target?.textContent)
              }}
              onInput={(e) => {
                content.chapitre[actIndex?.chapitre].partie[actIndex?.partie].sequence[actIndex?.sequence].exerciceTitle = e?.target?.textContent
                updateContent(content)
              }}
              onPaste={(e) => {
                e.preventDefault();
                var text = '';
                if (e.clipboardData || e.originalEvent.clipboardData) {
                  text = (e.originalEvent || e).clipboardData.getData('text/plain');
                } else if (window.clipboardData) {
                  text = window.clipboardData.getData('Text');
                }
                if (document.queryCommandSupported('insertText')) {
                  document.execCommand('insertText', false, text);
                } else {
                  document.execCommand('paste', false, text);
                }
              }}
            >
              {titreSequence}
            </Box>
          }
        </Box>
      </Box>
      <Box sx={{
        flex:1,
        overflowX:"hidden",
        overflowY:"auto",
        scrollbarWidth: "none",
        "::-webkit-scrollbar" :{
          display: "none",
        }
      }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppableChaps" type="droppableChaps">
            {(provided, snapshot) => (
              <Box
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {content?.chapitre?.map((chapitre, iChap) => {
                  return (
                    <SideBarChapitre
                      content={content}
                      updateContent={updateContent}
                      iChap={iChap}
                      id={chapitre?.id}
                      key={'plan_chap_' + chapitre?.id}
                      actIndex={actIndex}
                      setIndex={setIndex}
                    />
                  )
                })}
                {provided.placeholder}
              </Box>
            )}
          </Droppable>
        </DragDropContext>
        <Box
          sx={{
            paddingLeft:"7px",
            display:"flex",
            gap:"8px",
            height:"40px",
            alignItems:"center",
            fontSize:"17px",
            userSelect:"none",
            cursor:"pointer",
            borderBottom:"1px solid #2929292f"
          }}
          onClick={() => {
            addChapitre(content?.chapitre?.length, content?.chapitre?.length)
          }}
        >
          <img src={addForAdmin} style={{width:"16px"}} />
          <Box>Ajoutez un chapitre</Box>
        </Box>
        <Box
          sx={{
            paddingLeft:"7px",
            display:"flex",
            gap:"8px",
            height:"40px",
            alignItems:"center",
            fontSize:"17px",
            userSelect:"none",
            cursor:"pointer",
            borderBottom:"1px solid #2929292f",
            background:actIndex?.chapitre === "max" && "rgba(255,165,0, 0.2)",
          }}
          onClick={() => {
            setIndex({chapitre:"max", partie:0, sequence:0})
          }}
        >
          <img src={flagForAdmin} style={{width:"16px"}} />
          <Box>Fin de formation</Box>
        </Box>
      </Box>
      <Box sx={{
        borderTop:"1px solid black",
        paddingTop:"5px",
        paddingBottom:"5px",
        display:"flex",
        justifyContent:"center"
      }}>
        <Button
          variant="contained"
          sx={{minHeight:"35px !important"}}
          disabled={!playerHasChanged}
          onClick={(e) => {
            saveAdminContent(content)
          }}
        >
          Sauvegarder
        </Button>
      </Box>
    </Box>
  )
};

export default SideBar;
